/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum ReputationActionTaken {
  Dismissed = "Dismissed",
  Disputed = "Disputed",
  Shared = "Shared",
  SharedLive = "SharedLive",
}

export const ReputationActionTakenDisplay: Record<ReputationActionTaken, string> = {
  [ReputationActionTaken.Dismissed]: "Dismissed",
  [ReputationActionTaken.Disputed]: "Disputed",
  [ReputationActionTaken.Shared]: "Shared",
  [ReputationActionTaken.SharedLive]: "Shared Live",
};
